<template>
  <div class="modal fade" id="add-ticket" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <LoadingElement v-if="loading" />
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="add-ticket-close"
          ></button>
          <div class="text-center">
            <h4 class="">{{ $t("support_tickets.support_ticket") }}</h4>
          </div>
          <div class="row g-6">
            <div class="col-12" v-if="!support_ticket.account">
              <label class="form-label" for="selectpickerBasic">{{
                $t("accounts.username")
              }}</label>
              <!-- <Multiselect
                v-model="support_ticket.account_id"
                :options="accounts"
                @click="validate()"
                :trackBy="'value'"
                :label="'label'"
                :searchable="true"
              ></Multiselect> -->
            </div>
            <div class="col-12" v-if="support_ticket.account">
              <div class="input-group">
                <span class="input-group-text">{{
                  $t("accounts.username")
                }}</span>
                <input
                  type="text"
                  class="form-control"
                  aria-label="Username"
                  v-model="support_ticket.account.username"
                  :disabled="support_ticket.account"
                  @input="validate()"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="input-group">
                <span class="input-group-text">{{
                  $t("support_tickets.issue")
                }}</span>
                <textarea
                  class="form-control"
                  aria-label="Issue"
                  v-model="support_ticket.issue"
                  @input="validate"
                  :disabled="support_ticket.account"
                  :class="{ 'is-invalid': errors.issue }"
                ></textarea>
                <div v-if="errors.issue" class="invalid-feedback">
                  {{ errors.issue }}
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="selectpickerBasic">{{
                $t("support_tickets.status")
              }}</label>
              <select
                id="selectpickerBasic"
                class="form-select w-100"
                data-style="btn-default"
                v-model="support_ticket.status"
              >
                <option value="new" class="bg-label-primary">{{
                  $t("support_tickets.new")
                }}</option>
                <option value="in_progress" class="bg-label-warning">{{
                  $t("support_tickets.in_progress")
                }}</option>
                <option value="resolved" class="bg-label-success">{{
                  $t("support_tickets.resolved")
                }}</option>
                <option value="failed" class="bg-label-danger">{{
                  $t("support_tickets.failed")
                }}</option>
              </select>
            </div>
            <div class="col-sm-6">
              <label class="form-label" for="selectpickerBasic">{{
                $t("support_tickets.priority.priority")
              }}</label>
              <select
                id="selectpickerBasic"
                class="form-select w-100"
                data-style="btn-default"
                v-model="support_ticket.priority"
              >
                <option value="0" class="bg-label-secondary">{{
                  $t("support_tickets.priority.low")
                }}</option>
                <option value="1" class="bg-label-info">{{
                  $t("support_tickets.priority.normal")
                }}</option>
                <option value="2" class="bg-label-warning">{{
                  $t("support_tickets.priority.high")
                }}</option>
              </select>
            </div>
            <div class="col-12">
              <label class="form-label" for="">{{
                $t("support_tickets.phone")
              }}</label>
              <div class="input-group">
                <!-- <span class="input-group-text" id="basic-addon34">+</span> -->
                <input
                  type="text"
                  v-model="support_ticket.phone"
                  :disabled="support_ticket.account"
                  @input="validate"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="input-group">
                <span class="input-group-text">{{
                  $t("support_tickets.address")
                }}</span>
                <textarea
                  class="form-control"
                  v-model="support_ticket.address"
                  :disabled="support_ticket.account"
                  @input="validate"
                  aria-label="Address"
                ></textarea>
              </div>
            </div>
            <div class="col-12">
              <div class="input-group">
                <span class="input-group-text">{{
                  $t("support_tickets.notes")
                }}</span>
                <textarea
                  :disabled="support_ticket.account"
                  @input="validate"
                  v-model="support_ticket.notes"
                  class="form-control"
                  aria-label="Additional Notes"
                ></textarea>
              </div>
            </div>
            <div class="col-12">
              <div class="input-group">
                <span class="input-group-text">{{
                  $t("support_tickets.ssr_comment")
                }}</span>
                <textarea
                  class="form-control"
                  @input="validate"
                  v-model="support_ticket.ssr_notes"
                  aria-label="SSR Comment"
                ></textarea>
              </div>
            </div>
            <div class="col-12 d-flex justify-content-end">
              <button
                class="btn btn-success"
                @click.prevent="store"
                :disabled="!validated"
              >
                {{
                  this.support_ticket.id
                    ? $t("profiles.save")
                    : $t("profiles.add")
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "AddSupportTicket",
  data() {
    return {
      loading: false,
      support_ticket: {
        account_id: "",
        username: "",
        issue: "",
        phone: "",
        address: "",
        priority: "0",
        status: "new",
        notes: "",
        ssr_notes: "",
        created_at: "",
      },
      accounts: [],
      errors: {
        account_id: null,
        issue: null,
      },
      validated: true,
    };
  },
  props: {
    ticket: {
      type: Object,
      default: null,
    },
  },
  async created() {
    this.loading = true;
    await this.$nextTick();
    await this.fetchSupportTicket();
    // if (this.$route.query.ticket_id) {
    // } else {
    //   await this.fetchAccounts();
    // }
    this.loading = false;
  },
  methods: {
    async store() {
      try {
        if (this.support_ticket.account) {
          const res = await axios.put(
            `support/${this.support_ticket.id}`,
            this.support_ticket,
          );
          if (res.status == 200) {
            document.getElementById("add-ticket-close").click();
            this.$notify({
              text: this.$t("messages.support_ticket_updated_successfully"),
              type: "success",
            });
            this.$emit("updated");
          }
        } else {
          const res = await axios.post("support", this.support_ticket);
          if (res.status == 200) {
            document.getElementById("add-ticket-close").click();
            this.$notify({
              text: this.$t("messages.support_ticket_added_successfully"),
              type: "success",
            });
            this.$emit("updated");
          }
        }
      } catch (error) {
        document.getElementById("add-ticket-close").click();
        this.$notify({
          text: "Fail! ",
          type: "error",
        });
      }
    },
    async fetchAccounts() {
      const res = await axios.get("accounts?rows=1000000");
      const accounts = res.data.data;
      accounts.forEach((element) => {
        this.accounts.push({ value: element.id, label: element.username });
      });
    },
    async fetchSupportTicket() {
      if (this.ticket) {
        this.support_ticket = { ...this.ticket };
        if (this.support_ticket.account) {
          this.support_ticket.account_id = this.support_ticket.account.id;
        }
      }
      // const res = await axios.get(`support/${this.$route.query.ticket_id}`);
      // this.support_ticket = res.data.data;
      // this.support_ticket.account_id = this.support_ticket.account.id;
    },
    validate() {
      this.errors.account_id = null;
      this.errors.issue = null;
      this.validated = true;
      if (this.support_ticket.account_id == "") {
        this.errors.account_id = this.$t("errors.support_tickets.account_id");
        this.validated = false;
      }
      if (this.support_ticket.issue == "") {
        this.errors.issue = this.$t("errors.support_tickets.issue");
        this.validated = false;
      }
    },
  },
};
</script>
